import { Component, HostBinding, AfterContentInit, Input } from '@angular/core';
import { BaseDirective } from '../../../base.directive';
import { coerceBooleanProperty } from '@angular/cdk/coercion';

@Component({
    selector: 'eui-toolbar-items',
    templateUrl: './toolbar-items.component.html',
})
export class EuiToolbarItemsComponent extends BaseDirective implements AfterContentInit {

    @Input()
    get euiPositionRight() { return this._euiPositionRight; }
    set euiPositionRight(value) { this._euiPositionRight = coerceBooleanProperty(value); }
    _euiPositionRight = false;

    @HostBinding('class')
    get cssClasses() {
        const rootClass = 'eui-toolbar-items';
        return [
            this._euiPositionRight ? `${rootClass}--position-right` : ``,
            super.getCssClasses(rootClass),
        ].join(' ').trim();
    }

    constructor() {
        super();
    }

    ngAfterContentInit() {
        if (!this.e2eAttr) {
            this.e2eAttr = 'eui-toolbar-items';
        }
    }

}
